import { render, staticRenderFns } from "./ProfessionalDevelopmentLayout.vue?vue&type=template&id=64f56af2&"
import script from "./ProfessionalDevelopmentLayout.vue?vue&type=script&lang=js&"
export * from "./ProfessionalDevelopmentLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64f56af2')) {
      api.createRecord('64f56af2', component.options)
    } else {
      api.reload('64f56af2', component.options)
    }
    module.hot.accept("./ProfessionalDevelopmentLayout.vue?vue&type=template&id=64f56af2&", function () {
      api.rerender('64f56af2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/main-column/ProfessionalDevelopmentLayout.vue"
export default component.exports